import * as React from 'react';
import { IMessage } from '../Messages';
import MessageListQuery from '../Querys/MessageListQuery';
import MessageListUpdateMutation, {
  MessageUpdateType,
} from '../Mutations/MessageListUpdateMutation';
import MessageListDeleteMutation, {
  MessageDeleteType,
} from '../Mutations/MessageListDeleteMutation';

interface IProps {
  children: (args: IMessageState) => React.ReactNode;
}

interface IMessageState {
  messages: IMessage[];
  newMessages: boolean | null;
  updateMessage: MessageUpdateType;
  deleteMessage: MessageDeleteType;
  loading: boolean;
}

const MessageState: React.FC<IProps> = props => (
  <MessageListQuery>
    {(messages, loading) => (
      <MessageListUpdateMutation>
        {updateMessages => (
          <MessageListDeleteMutation>
            {deleteMessages =>
              props.children({
                messages: messages,
                newMessages: !loading
                  ? messages.some(x => !x.reciever.read)
                  : null,
                updateMessage: updateMessages,
                deleteMessage: deleteMessages,
                loading: loading,
              })
            }
          </MessageListDeleteMutation>
        )}
      </MessageListUpdateMutation>
    )}
  </MessageListQuery>
);

export default MessageState;
